enum TokenKey {
  TOKEN = "ci_hp",
}

export default TokenKey;
